// src/components/LoginForm.tsx
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import DefaultLayout from "../layouts/default/Default.layout";
import Table from "../components/Table/Table";
import {useEffect, useMemo} from "react";
import { Column, useTable } from "react-table";
import { Simulado } from "../../sdk/@types";
import { Button } from "antd";
import {useNavigate} from "react-router-dom";
import usePageTitle from "../../core/hooks/UsePageTitle";
import {useSimulado} from "../../core/hooks/useSimulado";

const schema = z.object({
  email: z.string().email("Invalid email"),
  password: z.string().min(6, "Min 6 chars"),
});

type FormData = z.infer<typeof schema>;

export default function ListarSimulado() {
  const { simulados, fetchSimulados, setSimulado } = useSimulado();

  usePageTitle("Listar Simulados");
  const navigate = useNavigate();

  const columns : Column<Simulado.Simulado>[] = useMemo(() => [
    {
      Header: 'Descrição',
      accessor: 'description',
    },
    {
      Header: 'Tipo',
      accessor: 'type',
    },
    {
      Header: 'Situação',
      accessor: 'situation',
    },
    {
      Header: 'Início',
      accessor: 'start',
      Cell: ({ value }) =>
        value ? (
          <strong>
            {`${new Date(value).toLocaleDateString('pt-BR')} ${new Date(value).toLocaleTimeString('pt-BR', {
              hour: '2-digit',
              minute: '2-digit',
            })}`}
          </strong>
        ) : (
          'Indefinido'
        ),
    },
    {
      Header: 'Fim',
      accessor: 'end',
      Cell: ({ value }) =>
        value ? (
          <strong>
            {`${new Date(value).toLocaleDateString('pt-BR')} ${new Date(value).toLocaleTimeString('pt-BR', {
              hour: '2-digit',
              minute: '2-digit',
            })}`}
          </strong>
        ) : (
          'Indefinido'
        ),
    },
    {
      Header: 'Ação',
      Cell:({row})=>(
        <div className="justify-center flex gap-2">
          <Button type="primary" onClick={() => handleRowClick(row.original!)}>
            Alterar
          </Button>
        </div>
      ),
    }
  ], []);

  const instance = useTable<Simulado.Simulado>({
    columns,
    data: simulados??[],
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormData>({ resolver: zodResolver(schema) });

  const onSubmit = (data: FormData) => {
    console.log(data);
  };

  useEffect(() => {
    fetchSimulados();
  }, [fetchSimulados]);

  const handleRowClick = (row: Simulado.Simulado) => {
    navigate(`/editar-simulado/${row.id}`, {state: {simulado: row}});
  };

  return (
    <DefaultLayout>
      <main>
        <Table instance={instance} />
      </main>
    </DefaultLayout>
  );
}
